export default __webpack_public_path__ + "static/media/subSection-picture.e5696bcd.jpg";